import { Suspense } from 'react'
import JourneyManagerBootstrapClient from './JourneyManagerBootstrapClient'

export default function JourneyManagerBootstrap() {
  /**
   * Why Suspense?
   * `JourneyManagerBootstrapClient` uses `useSearchParams()` (a client hook).
   * On statically rendered routes, Next.js may need to "bail out" to client-side
   * rendering for the subtree that reads search params; in production builds this
   * requires a nearest `<Suspense>` boundary, otherwise the build can fail.
   *
   * Why split files?
   * The `Suspense` boundary must wrap the component that calls `useSearchParams`,
   * but it can't be defined *inside* that same component (hooks run before JSX
   * is returned).
   */
  return (
    <Suspense fallback={null}>
      <JourneyManagerBootstrapClient />
    </Suspense>
  )
}
